<template>
<!-- This example requires Tailwind CSS v2.0+ -->
<div class="fixed z-10 inset-0 overflow-y-auto" :class="showModal?'':'hidden'" aria-labelledby="modal-title" role="dialog" aria-modal="true">
  <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
    <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>

    <!-- This element is to trick the browser into centering the modal contents. -->
    <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

    <div class="inline-block align-bottom bg-gray-700 rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">

        <div class="bg-gray-700 px-4 pt-5 pb-4 sm:pb-4">
          <div class="mt-3 text-center sm:mt-0 sm:text-left">
            <h3 class="text-lg uppercase text-3xl font-bold font-medium text-white mb-1">
              Error
            </h3>
          </div>

          <div class="mb-4">
            <label class="block text-white text-lg font-bold mb-2 font-bold">
              You first need to have a provider that you are admin of
            </label>
          </div>

          <div class="bg-gray-700 px-4 py-3 sm:px-6 flex justify-center">
            <button type="button" @click="toggleModal(false)" class="mt-3 w-full inline-flex justify-center shadow-sm px-8 py-2 bg-white text-white font-medium bg-teal-900 hover:bg-teal-700 focus:outline-none sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm">OK</button>
          </div>
        </div>

    </div>
  </div>
</div>
</template>

<script>
	export default {
		name: 'TourErrorModal',
    props: ['showModal', 'toggleModal'],
	}
</script>